import { ChevronLeft, ChevronRight } from "lucide-react"
import { cn } from "../../lib/utils"
import { Button } from "./button"

interface PeriodStepperProps {
  /** Omit for a compact arrows-only control. */
  label?: string
  onPrevious: () => void
  onNext: () => void
  previousLabel?: string
  nextLabel?: string
  className?: string
}

/** Segmented "‹ label ›" control for stepping through months, tax years, etc. */
function PeriodStepper({
  label,
  onPrevious,
  onNext,
  previousLabel = "Previous",
  nextLabel = "Next",
  className,
}: PeriodStepperProps) {
  return (
    <div
      className={cn(
        "inline-flex h-9 items-center rounded-lg border border-line-strong bg-raised/70 p-0.5 shadow-[inset_0_1px_0_rgb(255_255_255/0.04)]",
        className
      )}
    >
      <Button variant="ghost" size="icon-sm" className="size-7 rounded-md" onClick={onPrevious} aria-label={previousLabel}>
        <ChevronLeft />
      </Button>
      {label && (
        <span aria-live="polite" className="min-w-32 px-2 text-center text-[13px] font-medium text-fg">
          {label}
        </span>
      )}
      <Button variant="ghost" size="icon-sm" className="size-7 rounded-md" onClick={onNext} aria-label={nextLabel}>
        <ChevronRight />
      </Button>
    </div>
  )
}

export { PeriodStepper }
